// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { CheckBox } from '@gandi/ui';
import { ListCell, ListItem, ListRow, TitleCell } from '@gandi/ui/deprecated';

type Contract = {
  href: string,
  id: string,
  name: string,
};

export type ContractsProps = {
  approveContract: (name: string) => void,
  approvedContracts: Array<string>,
  contracts: Array<Contract>,
  translator: TranslatorProps,
  unApproveContract: (name: string) => void,
};

class Contracts extends React.Component<ContractsProps> {
  handleContractChange: (evt: SyntheticInputEvent<>) => void = (
    evt: SyntheticInputEvent<>,
  ) => {
    const name = evt.target.name;
    if (this.props.approvedContracts.indexOf(name) > -1) {
      this.props.unApproveContract(name);
    } else {
      this.props.approveContract(name);
    }
  };

  renderContract: (contract: Contract) => React.Node = (contract: Contract) => (
    <ListRow key={contract.id} separatorBottom>
      <CheckBox
        variant="block"
        name={contract.id}
        onChange={this.handleContractChange}
      >
        {contract.name}
      </CheckBox>
      <ListItem>
        <ListCell>
          {contract.name}
          {!!contract.href && (
            <span>
              &nbsp;
              <a href={contract.href} target="_blank" rel="noopener noreferrer">
                {this.props.translator.__('(see)')}
              </a>
            </span>
          )}
        </ListCell>
      </ListItem>
    </ListRow>
  );

  render(): React.MixedElement {
    const { __ } = this.props.translator;

    return (
      <div>
        <ListRow separatorBottom>
          <ListItem>
            <TitleCell>{__('Contracts to accept')}</TitleCell>
          </ListItem>
        </ListRow>
        {this.props.contracts.map(this.renderContract)}
      </div>
    );
  }
}

export default Contracts;
